module.exports = __webpack_public_path__ + "images/bannerPT-d1a0fd123f7e116d73e935be3a81a207.png";